import { render, staticRenderFns } from "./VisualizarVeiculo.vue?vue&type=template&id=c890a06c&"
import script from "./VisualizarVeiculo.vue?vue&type=script&lang=js&"
export * from "./VisualizarVeiculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports